import React from 'react';
import PropTypes from 'prop-types';
import { ListGroup } from 'react-bootstrap';

export default function ContactList({ children }) {
  return <ListGroup>{children}</ListGroup>;
}

ContactList.propTypes = {
  children: PropTypes.array.isRequired,
};
